<template>
  <div class="homeWrap">
      <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
export default {
  name: 'innerFrame',
  data () {
    return {
      isRouterAlive: true,
    }
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/innerFrame.vue